import { Server, Shield, Zap, Headphones, Globe, HardDrive } from "lucide-react";

const features = [
  {
    icon: Zap,
    title: "BDIX Connectivity",
    description: "Lightning-fast BDIX hosting with direct Bangladesh Internet Exchange connectivity for minimal latency and maximum speed.",
  },
  {
    icon: HardDrive,
    title: "NVMe SSD Storage",
    description: "Enterprise-grade NVMe SSDs delivering up to 40x faster read/write speeds for your Bangladesh web hosting.",
  },
  {
    icon: Shield,
    title: "99.99% Uptime SLA",
    description: "Industry-leading uptime guarantee backed by our robust BDIX infrastructure in Bangladesh.",
  },
  {
    icon: Headphones,
    title: "24/7 Expert Support",
    description: "Round-the-clock technical support from our certified Bangladesh hosting experts in Bangla and English.",
  },
  {
    icon: Server,
    title: "LiteSpeed Servers",
    description: "High-performance LiteSpeed web servers for blazing-fast page loads on all BDIX hosting plans.",
  },
  {
    icon: Globe,
    title: "Free SSL Certificate",
    description: "Secure your website with free Let's Encrypt SSL certificates included with every hosting plan.",
  },
];

const FeaturesSection = () => {
  return (
    <section className="py-20 bg-background" aria-labelledby="features-heading">
      <div className="container-custom">
        <div className="text-center mb-16 animate-fade-in-up">
          <span className="inline-block px-4 py-1.5 rounded-full bg-blue-50 text-primary text-sm font-medium mb-4">
            Why Choose Web Host Buy BD
          </span>
          <h2 id="features-heading" className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Enterprise-Grade BDIX Hosting Features
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Powering thousands of websites in Bangladesh with cutting-edge BDIX technology, affordable hosting prices in BD, and unmatched reliability.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <article
              key={feature.title}
              className="group p-6 rounded-2xl bg-card border border-border card-hover animate-fade-in-up text-center md:text-left"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="feature-icon mb-4 group-hover:scale-110 transition-transform duration-300 mx-auto md:mx-0" aria-hidden="true">
                <feature.icon className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-2">
                {feature.title}
              </h3>
              <p className="text-muted-foreground">
                {feature.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;